import { INVESTOR_FILE_STATUS, NICHE_FILE_STATUS, SKIP_TRACING_STATUS } from "@shared/models";

export enum ORDER_TYPE {
  ASC = "asc",
  DESC = "desc",
  NONE = "",
}

export enum ORDER_COLUMN_TYPE {
  CREATED_AT = "created_at",
  FIRST_NAME = "first_name",
  NAME = "name",
  RESOLVED_DATE = "resolved_date",
  PRIORITY = "priority",
  PROPERTY_ADDRESS = "property_address",
  LAST_SENT_AT = "last_sent_at",
}

export interface BaseFilter {
  page: number;
  limit: number;
  search?: string | null;
  order?: ORDER_COLUMN_TYPE;
  direction?: ORDER_TYPE;
}

export interface SkipTracingFilter extends BaseFilter {
  account_id: number | null;
  status?: SKIP_TRACING_STATUS;
}

export interface InvestorFileFilter extends BaseFilter {
  account_id: number | null;
  status?: INVESTOR_FILE_STATUS;
}

export interface NicheFilesFilter extends BaseFilter {
  account_id: number | null;
  status?: NICHE_FILE_STATUS;
}

export interface CountiesFilter extends BaseFilter {
  state_id?: number[];
}

export interface AccountsFilter extends BaseFilter {
  only_hubspot_companies?: boolean;
  status?: string;
}

export interface HubspotPropertiesHistoryFilter extends BaseFilter {
  account_id?: number | null;
}

export interface PayPerLeadFilter extends BaseFilter {
  stateId?: number;
  countyId?: number;
  monthOffset?: number;
  from: string;
  to: string;
}

export interface PayPerLeadCountiesFilter extends BaseFilter {
  stateId?: number;
  countyId?: number;
  onlyWithChanges?: boolean;
  onlyActive?: boolean;
}

export interface PropertiesFilter {
  search?: string | null;
  state_id?: number | null;
  county_id?: number | null;
}

export interface PayPerLeadStatisticsFilter {
  account_id?: number;
  state_id?: number;
  county_id?: number;
  status?: string;
  month?: string;
  from?: Date;
  to?: Date;
}

export interface PayPerLeadSubscriptionFilter {
  is_active?: boolean;
  is_paused?: boolean;
  is_non_renewing?: boolean;
  account_id?: number;
  state_id?: number;
  county_id?: number;
  month?: string;
}
